<template>
    <SideNav ref="sidenav" :check-close="onCheckClose" :check-page-close="onCheckPageClose" class="product-wizard">
        <div class="header header-wizard">
            <div class="corner">
                <div class="corner-inner">
                    <div class="wizard-container">
                        <Stepper v-model="step"
                                 :options="steps"
                                 class="stepper"
                                 @forward="step = $event.id"
                        />
                        <div class="step">
                            Шаг {{ step }} из {{ steps.length }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="$refs.sidenav.cancel()"></div>
                    </div>
                </div>
            </div>
        </div>

        <component :is="currentStep[step]"
                   :cluster="cluster"
                   :dicts="dicts"
                   :last="step === 4"
                   :loading="loading"
                   :office="office"
                   :value="value[step]"
                   can-select-main
                   class="wizard-step side-nav-inner"
                   @back="onBack"
                   @changed="changed = true"
                   @close="$refs.sidenav.cancel()"
                   @next="onNext"
        />

        <div v-if="confirmPublish" class="confirm">
            <div class="container">
                <div class="title">{{ confirmPublishTitle }}</div>
                <div class="message">
                    Полнота заполнения информации по продукту упрощает поиск и продвижение решения.<br>
                    Рекомендуем заполнить все поля описания продукта
                </div>
                <div class="buttons">
                    <input v-show="!moderateCard"
                           class="primary"
                           type="button"
                           value="Продолжить редактирование"
                           @click="close(createdProductId)"
                    >
                    <input :value="confirmPublishButton"
                           class="ghost cancel"
                           type="button"
                           @click="onPublish"
                    >
                </div>
            </div>
        </div>
    </SideNav>
</template>

<script>
import { documentsMap, getDocumentChanged } from '@/common/page_comp/Documents/fileApi.js';
import { updateInfoList } from '@/restapi/document/document.js';
import { DRAFT_STAGE_DICT } from '@/common/page_comp/Draft/draft.stage.dict.js';
import { MODERATE_CARD } from '@/common/rights.js';
import { hasRights } from '@/common/session.js';
import { save as saveContact } from '@/restapi/contact/contact.dict.js';
import { loadDicts, publication as publicationDraft, saveProduct } from '@/restapi/product/product.js';
import { showError } from '@dsee/components/popups/message.js';
import { newToast } from '@dsee/components/popups/toast.js';

import CreateContacts from '../common/CreateContacts.vue';
import CreateDocuments from '../common/CreateDocuments.vue';
import CreateMainInfo from './CreateMainInfo.vue';
import SelectBannerCover from './SelectBannerCover.vue';

import '@/common/page_comp/CreateCard/common/style.scss';


export default {
    components: {
        CreateMainInfo,
        CreateDocuments,
        CreateContacts,
        SelectBannerCover,
    },
    computed: {
        currentStep() {
            return {
                1: 'CreateMainInfo',
                2: 'CreateDocuments',
                3: 'CreateContacts',
                4: 'SelectBannerCover',
            };
        },
        moderateCard() {
            return hasRights([ MODERATE_CARD ]);
        },
        confirmPublishTitle() {
            return this.moderateCard ? 'Карточка продукта создана' : 'Черновик создан';
        },
        confirmPublishButton() {
            return this.moderateCard ? 'Ок' : 'Отправить на публикацию';
        },
    },
    data() {
        return {
            value: {
                1: {},
                2: {},
                3: {},
                4: {},
            },

            cluster: null,
            office: null,

            dicts: {
                productStatuses: [],
                industries: [],
                segments: [],
                backgrounds: [],
            },

            step: 1,
            steps: [],

            changed: false,
            loading: false,
            showConfirm: false,
            confirmPublish: false,

            createdProductId: null,
            createdProductReqt: null,
        };
    },
    methods: {
        reset() {
            this.value = {
                1: {},
                2: {},
                3: {},
                4: {},
            };
            this.changed = false;
            this.showConfirm = false;
            this.confirmPublish = false;
            this.steps = [
                { id: 1, complete: false, disabled: false },
                { id: 2, complete: false, disabled: true },
                { id: 3, complete: false, disabled: true },
                { id: 4, complete: false, disabled: true },
            ];
            this.step = 0;
            // тупо кастыль
            this.$nextTick(() => {
                this.step = 1;
            });
        },
        open(cluster, office) {
            this.reset();

            this.cluster = cluster;
            this.office = office;

            return this.$refs.sidenav.open();
        },
        close(data) {
            this.$refs.sidenav.accept(data);
        },
        save() {
            this.close(Object.assign({}, this.model));
        },
        onCheckClose(sidenav) {
            if (!this.changed)
                return true;

            return sidenav.showConfirm();
        },
        onBack(state) {
            Object.assign(this.value[this.step], state);

            this.step--;
        },
        onNext(state) {
            Object.assign(this.value[this.step], state);

            if (this.step === 4) {
                this.onCreate();
                return;
            }

            const stepIndex = this.step - 1;

            this.steps[stepIndex].complete = true;
            this.steps[stepIndex + 1].disabled = false;
            this.step++;
        },
        async onPublish() {
            if (this.moderateCard) {
                this.close(this.createdProductId);
                return;
            }

            try {
                const reqt = {
                    ...this.createdProductReqt,
                    id: this.createdProductId,
                    draftStage: DRAFT_STAGE_DICT.completed,
                };
                await saveProduct(reqt);

                this.close(this.createdProductId);

                newToast('Карточка продукта отправлена модератору');
            } catch (e) {
                showError('Произошла ошибка при переводе карточки продукта в статус "Готово к публикации" <br>', e);
                throw e;
            }
        },
        async onCreate() {
            this.loading = true;

            try {
                let draftStage = DRAFT_STAGE_DICT.inWork;
                if (this.moderateCard)
                    draftStage = DRAFT_STAGE_DICT.completed;

                // Сохраняем документы
                const documents = [];
                const documentGroups = [];

                try {
                    for (const it of this.value[2].documents) {
                        documents.push({ ...it.value, id: it.id, accessType: 'PUBLIC' });
                    }

                    for (const it of this.value[2].documentGroups) {
                        const documents = it.value.documents.map((it) => it.id);

                        documentGroups.push({
                            ...it.value,
                            documents,
                            accessType: 'PUBLIC',
                        });
                    }

                    // сохраняем обновлённую информацию о документах
                    const documentUpdateInfo = getDocumentChanged({
                        documents: this.value[2].documents,
                        documentGroups: this.value[2].documentGroups,
                    });
                    if (documentUpdateInfo.length)
                        await updateInfoList(documentsMap(documentUpdateInfo));
                } catch (e) {
                    showError('Произошла ошибка при сохранении документов <br>' + e);
                    throw e;
                }

                // Сохраняем контакты
                const contacts = [];
                try {
                    for (const it of this.value[3].contacts) {
                        const contact = { ...it.contact };

                        if (contact.id === -1) {
                            contact.id = null;
                            it.contact.id = await saveContact(contact);
                        }

                        contacts.push({ ...it, contact: it.contact.id });
                    }
                } catch (e) {
                    showError('Произошла ошибка при сохранении контактов <br>' + e);
                    throw e;
                }

                const main = this.value[1];
                const backgroundId = this.value[4].background.id;

                // Сохраняем продукт
                try {
                    const reqt = {
                        ...main,
                        documents,
                        documentGroups,
                        contacts,
                        draftStage,
                        backgroundId,
                    };

                    const productId = this.createdProductId = await saveProduct(reqt);
                    this.createdProductReqt = reqt;

                    if (this.moderateCard)
                        await publicationDraft(productId);

                    newToast('Карточка продукта успешно добавлена');
                } catch (e) {
                    showError('Произошла ошибка при сохранении продукта <br>' + e.message);
                    throw e;
                }

                if (draftStage === DRAFT_STAGE_DICT.inWork)
                    this.confirmPublish = true;

                if (!this.confirmPublish)
                    this.close(this.createdProductId);
            } finally {
                this.loading = false;
            }
        },
        onCheckPageClose() {
            if (!this.changed)
                return;

            const confirmation = confirm('Вы действительно хотите закрыть эту вкладку?');
            if (confirmation) {
                window.close();
            } else {
                event.preventDefault();
            }
        },
    },
    async created() {
        const dicts = await loadDicts();
        for (const key in dicts) {
            this.$set(this.dicts, key, dicts[key]);
        }
    },
};
</script>

<style lang="scss" scoped>
.product-wizard {
    width: 962px;
    @media (max-device-width: 767px) {
        width: 100vw;
    }

    .wizard-container {
        height: 48px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        display: flex;
        align-items: center;
        padding: 16px 32px;
        box-sizing: border-box;

        .stepper {
            flex-grow: 2;
            margin-right: 32px;
        }

        .step {
            color: rgba(131, 137, 151, 1);
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
        }
    }

    .confirm {
        .container {
            max-width: none;
        }

        .title {
            max-width: 378px;
        }

        .message {
            max-width: 378px;
        }
    }
}
</style>

<style lang="scss">
.tooltip.tooltip-select.inform {
    padding: 0;
    background-color: #fff;

    .action {
        display: flex;
        width: 100%;
        border: none;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        padding-left: 12px;

        &:hover {
            background: var(--option-hover-background)
        }
    }
}
</style>
